import type { JsonObject } from '../sticker_types';

/** Deep clone of a JSON-shaped value. Prevents accidental shared mutation
 * across the sticker boundary. */
export function deepCloneJson<T extends JsonObject>(value: T): T {
  if (typeof structuredClone === 'function') {
    return structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value)) as T;
}
